<template>
<section>
<v-card>
    <vuex-loader request-id='saveReqId' ></vuex-loader>
    <vuex-loader request-id='reqId' ></vuex-loader>
    <v-toolbar dense flat extended >
      <v-chip small label >{{invoice.status}}</v-chip>
      <v-text-field
        :loading='invoiceSaveRequest.loading'
        v-model='invoice.title' placeholder="Invoice title" ></v-text-field>
      <!-- <v-divider vertical ></v-divider> -->
      <!-- <v-btn flat >Mark as paid</v-btn>
      <v-btn flat >Send</v-btn>
      <v-btn flat >Add payment</v-btn>
      <v-btn flat >Download</v-btn> -->
      <v-spacer></v-spacer>
      <v-tooltip bottom >
        <v-btn slot='activator' @click='getInvoice' icon ><v-icon>replay</v-icon></v-btn>
        <span>Reload invoice data</span>
      </v-tooltip>
      <v-tooltip bottom >
        <v-btn v-if='invoice.relationship_id'
          @click='gotoRelationship(invoice.relationship_id)'
          slot='activator' icon ><v-icon class='ml-2' >person</v-icon></v-btn>
        <span>Show client</span>
      </v-tooltip>
      <v-tooltip bottom >
        <v-btn v-if='invoiceUrl'
          :href="invoiceUrl"
          target="_blank"
          slot='activator' icon ><v-icon class='ml-2' >open_in_new</v-icon></v-btn>
        <span>Open invoice preview in a new window</span>
      </v-tooltip>
      <v-tooltip bottom >
        <v-btn
          @click = "launchSendInvoiceDialog({ invoice: invoice, client: client, withClose: false })"
          slot='activator' icon ><v-icon class='ml-2' >send</v-icon></v-btn>
        <span>Send via email or sms</span>
      </v-tooltip>

      <v-layout slot="extension" >
        <v-breadcrumbs class='ml-2' divider="/">
            <v-breadcrumbs-item to='/invoices/' exact >Invoices</v-breadcrumbs-item>
            <v-breadcrumbs-item disabled>#{{invoice.id}}</v-breadcrumbs-item>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <v-btn
          @click='save' color='success' small :loading='invoiceSaveRequest.loading' >
          Save changes</v-btn>
      </v-layout>
    </v-toolbar>
</v-card>
<v-divider></v-divider>

<transition name='fade' >
<v-tabs
  dark class='mb-4'
  v-if='invoice.compatibility === 1 && invoice && invoice.id'
  v-model="activeTab" slider-color="yellow" >
  <v-tab >{{$t('tabs.edit')}}</v-tab>
  <v-tab @click='statementTouch++' >{{$t('tabs.statement')}}</v-tab>
  <v-tab @click='versionTouch++' >{{$t('tabs.versions')}}</v-tab>
  <v-tab >{{$t('tabs.communications')}}</v-tab>
  <!-- <v-tab >{{$t('tabs.rawData')}}</v-tab> -->

  <v-tab-item >
    <v-card>
      <v-card-title class='subheading hidden-sm-and-up grey lighten-4 hidden-xs-only' >
        #{{invoice.id}}
      </v-card-title>
      <v-card-title class='subheading  grey lighten-4' >
        <v-layout row wrap>
          <v-flex xs12 sm6 >
            <v-chip large label outline class='hidden-xs-only mt-2' >#{{invoice.id}}</v-chip >
          </v-flex>
          <!-- <v-spacer /> -->
          <v-flex xs12 sm6 style='text-align:right' >
            <v-list dense three-line
              v-if='invoice.encrypt_password'
              class='pa-0 elevation-2' >
              <v-list-tile >
                <v-list-tile-avatar >
                  <v-icon color='amber' class='mt-3'>lock</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class='overline' >
                    Password protected
                  </v-list-tile-title>
                  <v-list-tile-title v-text='invoice.encrypt_password' />
                  <v-list-tile-sub-title v-text='invoice.encrypt_password_hint' />
                </v-list-tile-content>
                <v-list-tile-action >
                  <v-btn @click='showEncrypt=true' icon >
                    <v-icon >edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-btn @click='showEncrypt=true' v-else >
              <v-icon small class='mr-2' >lock</v-icon>
              Add password
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-dialog v-model='showEncrypt' >
        <v-card>
          <v-card-title class='subtitle-1 overline py-0 grey lighten-4' >
            <v-icon small v-if='invoice.encrypt_password' class='mr-2' color='amber' >lock</v-icon>
            <v-icon small v-else class='mr-2' color='info' >lock_open</v-icon>
            Manage password
            <v-spacer/>
            <v-btn @click='showEncrypt=false' flat icon ><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>

          <encrypt-invoice class='mt-3'
            :password.sync='invoice.encrypt_password'
            :password-hint.sync='invoice.encrypt_password_hint' />

          <v-card-actions >
            <v-btn @click='showEncrypt=false' flat >cancel</v-btn>
            <v-spacer/>
            <v-btn color='primary'
              :loading='invoiceSaveRequest.loading'
              @click='savePassword' >save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-divider></v-divider>
      <invoice-detail
        @save="save"
        @refresh="getInvoice"
        :loading='invoiceSaveRequest.loading'
        v-model='invoice' ></invoice-detail>
    </v-card>
  </v-tab-item>
  <v-tab-item >
    <v-card flat >
      <v-card-title  class='subheading' >
        {{ $t('tabs.statement') }}
        <v-spacer></v-spacer>
      </v-card-title>
      <!-- <payment :invoice='invoice' ></payment> -->
      <v-divider></v-divider>
      <blockquote class='blockquote' >
        Here is a breakdown of the appointments in this invoice:
      </blockquote>
      <invoice-payments
        :invoice='invoice'
        :transactions='invoice.transaction_set' >
      </invoice-payments>
      <br/>
    </v-card>
  </v-tab-item>
  <v-tab-item >
    <v-card flat >
      <v-card-title class='subheading' >
        <help-popover>
          Every change you make to invoices is recorded and safely stored
          in the cloud as a pdf. You can view all versions of this document below
        </help-popover>
        {{ $t('tabs.versions') }}
        <v-spacer  ></v-spacer>
        <v-btn @click='versionTouch++' icon >
          <v-icon >replay</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <invoice-versions
        v-if='invoice && invoice.id'
        :touch='versionTouch'
        :invoice='invoice' ></invoice-versions>

    </v-card>
  </v-tab-item>
  <v-tab-item >
    <v-card flat >
      <v-card-title  class='subheading' >
        {{ $t('tabs.communications') }}
        <v-spacer></v-spacer>
        <v-btn @click='commsTouch++' :loading='invoiceCommsRequest.loading' icon ><v-icon>replay</v-icon></v-btn>
      </v-card-title>
      <invoice-communications
        v-if='invoice && invoice.id'
        :touch='commsTouch'
        :req-id='commsreqid'
        :invoice-id='invoice.id' >
      </invoice-communications>
    </v-card>
  </v-tab-item>
  <!-- <v-tab-item >
    <v-card>
    <pre>{{invoice}}</pre>
    </v-card>
  </v-tab-item> -->
</v-tabs>
</transition>
</section>
</template>

<script>
import InvoiceDetail from '@/components/invoice/InvoiceDetail'
import InvoiceVersions from '@/components/invoice/InvoiceVersions'
import InvoicePayments from '@/components/invoice/InvoicePayments'
import InvoiceCommunications from '@/components/invoice/InvoiceCommunications'
import EncryptInvoice from '@/components/invoice/manage/create/encrypt.vue'
import HelpPopover from '@/components/ui/HelpPopover'
import axios from 'axios'

export default {
  name: 'InvoiceDetailPage',
  components: {
    InvoiceDetail,
    InvoicePayments,
    InvoiceVersions,
    InvoiceCommunications,
    HelpPopover,
    EncryptInvoice
  },
  data () {
    return {
      reqId: 'req-invoice-' + this.invoiceId,
      saveReqId: 'invoice-save-request',
      commsreqid: 'communication-invoice-id',
      showEncrypt: false,
      showAlert: true,
      activeTab: null,
      invoice: {},
      versionTouch: 1,
      statementTouch: 1,
      commsTouch: 1
    }
  },
  mounted () {
    this.getInvoice()
  },
  watch: {
    invoiceId () {
      this.getInvoice()
    },
    invoiceResult () {
      console.log(this.invoiceResult)
      this.invoice = this.invoiceResult
    },
    invoiceSaveRequestStatus () {
      if (this.invoiceSaveRequestStatus === 200) {
        this.showEncrypt = false
      }
    }
  },
  computed: {
    invoiceId () {
      return this.$route.params.id
    },
    invoiceGetRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    invoiceSaveRequest () {
      return this.$store.getters.getRequestById(this.saveReqId, true)
    },
    invoiceSaveRequestStatus () {
      return this.invoiceSaveRequest.status
    },
    invoiceCommsRequest () {
      return this.$store.getters.getRequestById(this.commsreqid, true)
    },
    invoiceResult () {
      return this.getObjectPath(this.invoiceGetRequest, 'result.data', {})
    },
    invoiceUrl () {
      if (this.invoice) {
        return `${this.$invoiceguru.baseUrl}/${this.invoice.get_view_url}`
      }
    },
    client () {
      if (this.invoice) {
        return this.getClientById(this.invoice.customer_id)
      }
    }
  },
  methods: {
    getInvoice () {
      if (this.invoiceId) {
        this.$invoiceguru
          .resource('invoices')
          .id(this.reqId)
          .get(this.invoiceId)
      }
    },
    savePassword () {
      let data = {
        encrypt_password: this.invoice.encrypt_password,
        encrypt_password_hint: this.invoice.encrypt_password_hint
      }
      this.$invoiceguru
        .resource('invoices')
        .id(this.saveReqId)
        .save(this.invoice.id, data)
    },
    save () {
      let data = JSON.stringify(this.invoice)
      this.$invoiceguru
        .resource('invoices')
        .id(this.saveReqId)
        .save(this.invoice.id, data)
    },
    openInNew () {
      window.open(this.invoiceUrl, '_blank')
    },
    reloadIframe () {
      let iframe = document.getElementById('invoice-preview')
      iframe.contentWindow.location = this.invoiceUrl
    },
    upgradeInvoice () {
      let url = `${this.$invoiceguru.baseUrl}/invoices/${this.invoiceId}/upgrade/`
      let options = this.$invoiceguru.getOptions()
      let vm = this
      axios.get(url, options)
        .then(() => {
          vm.getInvoice()
        })
    }
  },
  i18n: {
    messages: {
      en: {
        tabs: {
          edit: 'Edit',
          statement: 'Statement',
          versions: 'Versions',
          communications: 'Communications',
          rawData: 'Raw data'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Invoice.vue?154c215f